import { useMemo } from 'react';
import { useStoreApi } from '../store';
import { createInstance } from './createInstance';
import type { CustomMindmapInstance } from './createInstance';

/** The canvas instance; works anywhere inside the provider, also outside the canvas (D-018). */
export const useCustomMindmap = (): CustomMindmapInstance => {
  const store = useStoreApi();
  return useMemo(() => createInstance(store), [store]);
};
